import { render, staticRenderFns } from "./BannerCard.vue?vue&type=template&id=60b96436&scoped=true&"
import script from "./BannerCard.vue?vue&type=script&lang=js&"
export * from "./BannerCard.vue?vue&type=script&lang=js&"
import style0 from "./BannerCard.vue?vue&type=style&index=0&id=60b96436&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b96436",
  null
  
)

export default component.exports